import * as React from 'react';

export interface SchemaOrgScriptProps {
  structuredData: string;
}

/**
 * Adds schema.org structured data on to the page
 */
export class SchemaOrgScript extends React.PureComponent<SchemaOrgScriptProps> {
  public render() {
    const { structuredData } = this.props;

    if (!structuredData) {
      return null;
    }

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: structuredData }} />;
  }
}
